import storage, { StorageType } from '@/utils/storage'
import { useMutation } from '@vue/apollo-composable'
import * as gql from '@/graphql'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import { ref } from 'vue'
import { nanoid } from 'nanoid'
import { LoginType } from '../model/loginModel'

export const useRegisterDevice = () => {
  const { mutate } = useMutation(gql.registerDevice, {
    clientId: 'dmz'
  })
  const registerDevice = async (): Promise<boolean> => {
    const params = {
      hwId: nanoid(),
      installId: nanoid(),
      versionName: 'web',
      versionCode: 1,
      platform: 'android'
    }
    try {
      const res: any = await mutate({ params })
      const result = res?.data?.registerDevice
      if (result?.ok) {
        storage.rcSetItem(StorageType.local, 'deviceId', result.data.deviceId)
        return true
      }
    } catch (err) {
      console.log('registerDevice failed', err)
    }
    return false
  }
  /**
   * 签名头里的 gh-deviceid 缺失会让登录之后的业务接口和行情推送全部鉴权失败，
   * 所以发起登录前必须确保设备号已经落到缓存里，不能只在页面初始化时补一次。
   */
  const ensureDeviceId = async (): Promise<boolean> => {
    if (storage.rcGetItem(StorageType.local, 'deviceId')) return true
    return registerDevice()
  }
  return {
    registerDevice,
    ensureDeviceId
  }
}

export const useLogin = (loginForm: LoginType) => {
  const router = useRouter()
  const promptDialog = ref(false)
  // 2fa
  const confirmPopupFlag = ref(false)
  const phoneMessage = ref({})
  const { mutate, onDone } = useMutation(gql.lpoaLoginManager, {
    clientId: 'dmz'
  })
  onDone(res => {
    const { lpoaLoginManager } = res?.data
    if (lpoaLoginManager.ok) {
      // 缓存必须先写完再跳转：路由守卫和 Layout 初始化都依赖 sessionId
      storage.rcSetItem(
        StorageType.local,
        'sessionId',
        lpoaLoginManager.data.sessionId
      )
      storage.rcSetItem(
        StorageType.local,
        'userInfo',
        lpoaLoginManager.data.manager
      )
      // 延迟行情 extendedQuotation
      storage.rcSetItem(
        StorageType.local,
        'extendedQuotation',
        lpoaLoginManager.data.isDelay
      )
      ElMessage({
        message: '登录成功',
        type: 'success',
        customClass: 'custom-success'
      })
      router.push({
        path: '/lpoa/realTimeData'
      })
    } else {
      if (lpoaLoginManager?.reason?.err === 33142) {
        confirmPopupFlag.value = true
        const obj = JSON.parse(lpoaLoginManager?.reason?.desc)
        phoneMessage.value = {
          username: loginForm.username,
          password: loginForm.password,
          ...obj
        }
      } else if (lpoaLoginManager?.reason?.err === 40008) {
        // 修改密码
        promptDialog.value = true
      } else {
        ElMessage({
          message: lpoaLoginManager?.reason?.desc,
          type: 'error',
          customClass: 'custom-error'
        })
      }
    }
  })
  return {
    loginDirect: mutate,
    promptDialog,
    confirmPopupFlag,
    phoneMessage
  }
}
